import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentProductClassOptions } from './normalize';

export const fetchShipmentProductClassOptions = createProvider(api.fetchShipmentProductClassOptions)
  .andThen((res) => normalizeShipmentProductClassOptions(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
